import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: '¿Sirve si nunca usé IA antes?',
    a: 'Sí. El Tomo 1 arranca desde cero absoluto. En menos de una hora tenés tu primera IA configurada y produciendo resultados reales. No necesitás conocimientos previos de tecnología.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'Todo en PDF de alta calidad, listo para descargar desde cualquier dispositivo. Acceso inmediato después del pago. Los prompts tienen botones linkeables directos a cada IA.'
  }, {
    q: '¿Qué lo diferencia del contenido gratuito de YouTube?',
    a: 'El contenido de YouTube te da piezas sueltas. Este pack te da el sistema completo. La diferencia está en que acá sabés exactamente qué hacer, en qué orden, con qué IA y por qué. Sin improvisar.'
  }, {
    q: '¿Para qué tipo de persona es este Mega Pack?',
    a: 'Para cualquier persona de habla hispana que use o quiera usar IA en su trabajo, negocio o vida profesional. No importa el rubro. Los sistemas funcionan para cualquier industria.'
  }, {
    q: '¿Funciona en todos los países?',
    a: 'Sí. El contenido está en español neutro y los ejemplos están adaptados para Argentina, México, Colombia, Chile y el resto de Latinoamérica. Los precios en ARS son para Argentina. Para el resto del mundo el precio es en USD.'
  }, {
    q: '¿Necesito pagar suscripciones de las IAs?',
    a: 'No. Todo el pack está diseñado para las versiones 100% gratuitas de ChatGPT, DeepSeek y Claude. Sin tarjeta. Sin suscripción. Sin costo extra.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 bg-dark" data-id="element-67">
      <div className="max-w-3xl mx-auto px-4 sm:px-6" data-id="element-68">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-69">
          <h2 className="text-3xl md:text-4xl font-display font-bold text-white" data-id="element-70">
            ❓ LO QUE MÁS NOS PREGUNTAN
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-71">
          {faqs.map((faq, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="glass-card rounded-xl border border-white/10 overflow-hidden" data-id="element-72">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-6 py-4 text-left flex items-center justify-between focus:outline-none" data-id="element-73">
                <span className="font-bold text-white pr-4" data-id="element-74">{faq.q}</span>
                <ChevronDown className={`w-5 h-5 text-cyan-400 transition-transform duration-300 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-75" />
              </button>
              <AnimatePresence data-id="element-76">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-77">
                    <div className="px-6 pb-4 text-gray-400 leading-relaxed border-t border-white/5 pt-4" data-id="element-78">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}